<div *ngIf="isVisitorInfoFieldBlockVisible" class="visitor-info-field-block">
  <div class="visitor-info-field-block-header" (click)="toggleBlock()">
    <span class="visitor-info-field-block-toggle">
      <svg-icon icon="{{ isBlockOpen ? 'arrow-down' : 'arrow-right' }}" class="arrow-icon"></svg-icon>
    </span>
    <span class="visitor-info-field-block-title">{{ title | translate }}</span>
  </div>
  <div class="visitor-info-item"
       *ngFor="let visitorInfoField of getVisitorInfoFieldsObjectKeys(); trackBy: trackByObjectKey"
       [hidden]="!isBlockOpen">

    <app-visitor-info-field *ngIf="visitorInfoFieldBlock[visitorInfoField].value !== undefined"
                            [visitorInfoField]="visitorInfoFieldBlock[visitorInfoField]"
                            [isNotAvailableDataHidden]="isNotAvailableDataHidden">
    </app-visitor-info-field>

    <div *ngIf="visitorInfoFieldBlock[visitorInfoField].operator && isBlockOpen">
      <hr />
      <div class="criterion-title">{{ 'bcVisitorInfo.criterion' | translate }}</div>

      <app-visitor-campaign-criterion-block class="outreach-criterion"
                                            [campaignConditions]="visitorInfoFieldBlock[visitorInfoField]">
      </app-visitor-campaign-criterion-block>

    </div>
  </div>
</div>
